export default __webpack_public_path__ + "static/media/java.cc2cc090.svg";